<template>
  <q-layout view="hHh Lpr lff" :style="this.layoutStore.isDarkMode ? 'background-color: #232323':'background-color: #FAFAFA'">
    <q-drawer :width="this.layoutStore.left_side_width"
              :breakpoint="300"
              v-model="this.getLeftSideState"
              :mini="!this.getLeftSideState || miniState"
              @click.capture="drawerClick"
              side="left"
              v-if="!closing && !focusMode"
    >
      <div class="column no-wrap" style="height: 100%;padding-bottom: 50px">

        <q-scroll-area v-if="menus!==undefined" class="col">

          <div v-if="menus">
            <tree-menu
                v-for="(item,idx) in menus"
                v-bind:key="idx"
                :label="item.label"
                :nodes="item.nodes"
                :icon="item.icon"
                :to="item.to"
                :mode="item.mode"
                :depth="0"
            ></tree-menu>
          </div>
        </q-scroll-area>

      </div>
      <q-footer v-if="this.getLeftSideState && !miniState" style="left: 0px;border-top:1px solid grey"
                :class="$q.dark.isActive ? 'bg-dark text-white' : 'bg-white text-grey-9'">

        <!-- Pied du menu : astuce du jour, notifications, effet de Noël, mode sombre et déconnexion -->
        <div class="row no-wrap items-center justify-end q-gutter-x-xs q-px-md q-py-sm"
             :class="$q.dark.isActive ? 'text-white' : 'text-grey-9'">
          <!-- Build (commit git) de l'interface, 4 derniers caractères : dit si ce client a la bonne version -->
          <div v-if="frontBuild" class="main-layout-build text-caption q-mr-auto"
               :class="$q.dark.isActive ? 'text-grey-5' : 'text-grey-6'">
            #{{ frontBuild.slice(-4) }}
          </div>
          <q-btn flat round dense size="sm" icon="lightbulb" @click="$refs.tip.show()">
            <q-tooltip>Astuce du jour</q-tooltip>
          </q-btn>
          <!-- Notifications reçues, activation push, son -->
          <app-notification-bell />
          <!-- Bouton Noël festif -->
          <q-btn
              flat round dense
              size="sm"
              icon="ac_unit"
              class="christmas-btn"
              @click="triggerChristmas"
          >
            <q-tooltip>Effet de Noël</q-tooltip>
          </q-btn>
          <q-btn flat round dense size="sm" :icon="isDarkMode ? 'dark_mode' : 'light_mode' " @click="toggleMode">
            <q-tooltip>{{ isDarkMode ? 'Mode clair' : 'Mode sombre' }}</q-tooltip>
          </q-btn>
          <q-btn flat round dense size="sm" icon="exit_to_app" @click="logOut">
            <q-tooltip>Déconnexion</q-tooltip>
          </q-btn>
        </div>

      </q-footer>

      <!-- Séparateur : la largeur du menu se règle en le faisant glisser (double-clic : largeur d'origine) -->
      <div v-if="this.layoutStore.isDesktop && this.getLeftSideState && !miniState"
           :class="['main-layout-splitter', {'main-layout-splitter--active': resizing}]"
           @mousedown.prevent="onSplitterStart"
           @dblclick="resetDrawerWidth">
        <q-tooltip :delay="600" anchor="center right" self="center left">Faire glisser pour redimensionner le menu</q-tooltip>
      </div>

      <div class="q-mini-drawer-hide absolute" style="top: 20px; right: 0px; z-index: 999">
        <q-btn
            size="sm"
            dense
            elevated
            color="pappus"
            icon="chevron_left"
            @click="miniState = true"
        />
      </div>


    </q-drawer>

    <!-- Composant de synchronisation -->
    <div class="q-mr-md">
      <app-sync ref="syncComponent" />
    </div>

    <!-- Composant d'effet de Noël -->
    <christmas ref="christmasEffect" />

    <!-- Astuce du jour : s'ouvre uniquement par le bouton du pied du menu -->
    <dashboard-tip ref="tip" />

    <!-- Notification affichée en entier (clic sur une notification système ou dans la cloche) -->
    <app-notification-viewer />

    <q-page-container>
      <router-view/>
    </q-page-container>
  </q-layout>


</template>

<script>
import TreeMenuCmp from "components/menu/TreeMenu.vue";

import AppMenuService from "src/services/utils/appMenuService"
import AuthService from "src/services/authService"
import {mapStores} from "pinia";
import {useLayoutStore, LEFT_SIDE_WIDTH} from "src/stores/layoutStore";
import {useAuthStore} from "src/stores/authStore";
import {useMenuStore} from "src/stores/menuStore";
import {Dark} from "quasar";
import AppEnvService from "../services/utils/appEnvService";
import NavigationService from "../services/navigationService";
import WebSocketService from "../services/webSocketService";
import NetworkService from "../services/networkService";
import Christmas from "../components/Christmas.vue";
import AppPushService from "../services/appPushService";
import AppInboxService from "../services/appInboxService";
import AppUpdateService from "../services/appUpdateService";
import AppNotificationBell from "../components/common/appNotificationBell.vue";
import AppNotificationViewer from "../components/common/appNotificationViewer.vue";
import {useAppInboxStore} from "../stores/appInboxStore";

export default {
  data() {
    return {
      tree: [],
      miniState: false,
      closing: false,
      left: false,
      // Redimensionnement du menu de gauche en cours : {x, width} au début du glissement
      resizing: null,
    };
  },
  components: {
    Christmas,
    AppNotificationBell,
    AppNotificationViewer,
    treeMenu: TreeMenuCmp,
  },
  watch: {
    // On quitte la fiche ouverte seule : le menu de gauche revient
    $route(to) {
      const focus = this.layoutStore.focus_route
      if (focus && !(to.name === focus.name && to.params.id === focus.id)) {
        this.layoutStore.setFocusRoute(undefined)
      }
      // Arbre du référentiel : l'endroit mémorisé ne sert qu'au retour direct sur la grille du module
      const saved = this.layoutStore.tree_state
      if (saved) {
        const onFiche = to.name === saved.target.name && to.params.id === saved.target.params.id
        if (!onFiche && to.name !== saved.root + "-grid") this.layoutStore.setTreeState(null)
      }
    },
  },
  computed: {
    ...mapStores(useLayoutStore, useAuthStore, useMenuStore),
    // Build (commit git) de l'interface, affiché dans le pied de page
    frontBuild() {
      return AppUpdateService.frontBuild
    },
    networkStatus() {
      return NetworkService.status
    },

    syncProgress() {
      return this.cacheStore.getSyncProgress
    },
    isDarkMode() {
      return Dark.mode
    },
    menus() {
      // Entrées des outils de prix : seulement si le switch de la fiche utilisateur est activé (suivi en direct)
      const priceTools = !!(this.authStore.currentUser?.isAdmin && this.authStore.currentUser?.priceTools)
      const visible = (menu) => priceTools || !menu.price_tools_only
      const menus = this.menuStore.menus
      return Array.isArray(menus)
        ? menus.filter(visible).map((menu) => (menu.nodes ? {...menu, nodes: menu.nodes.filter(visible)} : menu))
        : menus
    },
    getLeftSideState() {
      return this.layoutStore.getLeftSideState
    },
    // Fiche ouverte seule (depuis l'arbre du référentiel) : le menu de gauche est masqué
    focusMode() {
      const focus = this.layoutStore.focus_route
      return !!focus && this.$route.name === focus.name && this.$route.params.id === focus.id
    },
    currentUser() {
      return this.authStore.currentUser
    },
    searchTxt: {
      get: function () {
        return this.layoutStore.searchFilter
      },
      set: function (val) {
        this.layoutStore.setSearchFilter(val)
      },
    },
  },
  methods: {

    onSplitterStart(event) {
      this.resizing = {x: event.clientX, width: this.layoutStore.left_side_width}
      document.addEventListener('mousemove', this.onSplitterMove)
      document.addEventListener('mouseup', this.onSplitterEnd)
    },
    onSplitterMove(event) {
      // Le contenu garde au moins la moitié de la fenêtre
      const width = Math.min(this.resizing.width + event.clientX - this.resizing.x, window.innerWidth / 2)
      this.layoutStore.setLeftSideWidth(width)
    },
    onSplitterEnd() {
      document.removeEventListener('mousemove', this.onSplitterMove)
      document.removeEventListener('mouseup', this.onSplitterEnd)
      if (this.resizing) this.layoutStore.updateStorage()
      this.resizing = null
    },
    resetDrawerWidth() {
      this.layoutStore.setLeftSideWidth(LEFT_SIDE_WIDTH.default)
      this.layoutStore.updateStorage()
    },
    triggerChristmas() {
      this.$refs.christmasEffect.trigger()
    },
    drawerClick(e) {
      // if in "mini" state and user
      // click on drawer, we switch it to "normal" mode
      if (this.miniState) {
        this.miniState = false

        // notice we have registered an event with capture flag;
        // we need to stop further propagation as this click is
        // intended for switching drawer to "normal" mode only
        e.stopPropagation()
      }
    },
    logOut() {
      // Boîte de réception propre à l'utilisateur : vidée à la déconnexion
      useAppInboxStore().clear()
      this.authStore.logout()
      NavigationService.goToLogin()
    },
    async loadEnvVariables() {
      await AppEnvService.list()
    },
    async loadMenus() {
      if (this.currentUser) {
        await AppMenuService.list();
      } else {
        await AuthService.logout()
      }
    },
    toggleMode() {
      this.layoutStore.toggleDarkMode()
      Dark.set(this.layoutStore.isDarkMode)
    },
    initDarkMode() {
      Dark.set(this.layoutStore.isDarkMode === true)
    },
    checkChristmasSeason() {
      const now = new Date()
      const month = now.getMonth()
      const day = now.getDate()

      // Déclencher automatiquement entre le 20 et 27 décembre
      if (month === 11 && day >= 20 && day <= 27) {
        setTimeout(() => {
          this.triggerChristmas()
        }, 2000) // Attendre 2 secondes après le chargement
      }
    }
  },

  created() {
    if (!this.layoutStore.isDesktop) {
      this.layoutStore.left_side_state = false
    }
    // Page affichée dans un dialogue d'un autre écran (appFicheDialog) : seule, sans le menu de gauche
    if (this.$route.query.embedded) {
      this.layoutStore.setFocusRoute({name: this.$route.name, id: this.$route.params.id})
    }
    this.initDarkMode()
    // Ensure websocketService is up
    WebSocketService.getInstance().connect();
    this.loadEnvVariables().then(() =>
        this.loadMenus()
    )
  },

  mounted() {
    this.checkChristmasSeason()
    const syncPush = () => AppPushService.syncState().catch((error) => console.warn('Push state unavailable', error))
    syncPush()
    // Premier chargement : le service worker s'enregistre souvent après le montage
    navigator.serviceWorker?.ready.then(syncPush)
    // Boîte de réception : liste + réception en temps réel
    if (this.currentUser) AppInboxService.init()
  },

  beforeUnmount() {
    this.onSplitterEnd()
  }
};
</script>

<style lang="scss">

// Commit git de l'interface dans le pied de page
.main-layout-build {
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.navigation-item {
  border-radius: 5px;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 14px;
}

.tab-active {
  background-color: $pappus !important;
}

.full-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

/* Séparateur du menu de gauche : bande fine sur son bord droit */
.main-layout-splitter {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 6px;
  cursor: col-resize;
  z-index: 998;
  transition: background 0.2s ease;
}

.main-layout-splitter:hover,
.main-layout-splitter--active {
  background: rgba(107, 154, 60, 0.35);
}

.christmas-btn {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

</style>